export default __webpack_public_path__ + "static/media/frame-3.7cf1d2a2.png";